import { Layout } from "antd";
import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";

export const StyledFooter = styled(Layout.Footer)`
    padding: 9px 16px;
    height: 60px;
    display: flex;
    justify-content: space-around;
    gap: 4px;
`;

export const StyledNavLink = styled(NavLink)<{
    $isActive?: boolean;
    $disabled?: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.primaryTypographyColor};
    font-size: 10px;

    ${({ $disabled }) =>
        $disabled &&
        css`
            pointer-events: none;
            opacity: 0.4;
        `}

    &:hover {
        color: ${({ theme }) => theme.additionalTypographyColor};
    }

    svg {
        font-size: 22px;
    }

    ${({ $isActive, theme }) =>
        $isActive !== undefined
            ? $isActive &&
              `
                color: ${theme.additionalTypographyColor};
                
                .ant-badge svg {
                    color: ${theme.additionalTypographyColor};
                }
            `
            : `
                &[aria-current="page"] {
                    color: ${theme.additionalTypographyColor};
                    
                    .ant-badge svg {
                        color: ${theme.additionalTypographyColor};
                    }
                }
            `}
`;
